var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.33317V6.59984C16.5 5.57308 16.5 5.05969 16.3002 4.66752C16.1244 4.32255 15.8439 4.04209 15.499 3.86633C15.1069 3.6665 14.5934 3.6665 13.5667 3.6665H5.68333C4.65657 3.6665 4.14319 3.6665 3.75102 3.86633C3.40605 4.04209 3.12559 4.32255 2.94982 4.66752C2.75 5.05969 2.75 5.57308 2.75 6.59984V7.33317M2.75 7.33317V15.3998C2.75 16.4266 2.75 16.94 2.94982 17.3322C3.12559 17.6771 3.40605 17.9576 3.75102 18.1333C4.14319 18.3332 4.65657 18.3332 5.68333 18.3332H16.3167C17.3434 18.3332 17.8569 18.3332 18.249 18.1333C18.5939 17.9576 18.8744 17.6771 19.0502 17.3322C19.25 16.94 19.25 16.4266 19.25 15.3998V10.2665C19.25 9.23975 19.25 8.72636 19.0502 8.33419C18.8744 7.98922 18.5939 7.70876 18.249 7.53299C17.8569 7.33317 17.3434 7.33317 16.3167 7.33317H2.75ZM19.25 10.9998H17.4167C16.4041 10.9998 15.5833 11.8206 15.5833 12.8332C15.5833 13.8457 16.4041 14.6665 17.4167 14.6665H19.25",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.5d1647eff0fb3f5b80eb6f7657544ca3.svg";
export { ForwardRef as ReactComponent };